// General
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import { Button, Modal } from 'react-bootstrap';

import { closeProviderApprovalModal } from '../../../actions/siteadmin/modalActions';
import messages from '../../../locale/messages';
import { editPartner } from '../../../actions/siteadmin/editPartner';

//Style
import cs from '../../commonStyle.css';
import s from './ProviderApprovalModal.css';

const ProviderApprovalModal = ({ }) => {
    const providerApproval = useSelector(state => state?.adminModalStatus?.providerApprovalModal);
    const providerApprovalData = useSelector(state => state?.adminModalStatus?.providerApprovalData);
    const dispatch = useDispatch();

    const handleApprove = async () => {
        if (providerApprovalData) {
            await dispatch(editPartner(providerApprovalData));
        }
        dispatch(closeProviderApprovalModal());
    };

    const handleCancel = () => {
        if (providerApprovalData?.previousStatus) {
            providerApprovalData.userStatus = providerApprovalData.previousStatus;
        }
        dispatch(closeProviderApprovalModal());
    };

    return (
        <Modal show={providerApproval} onHide={() => dispatch(closeProviderApprovalModal())} dialogClassName='commonModalContainer'>
            <Modal.Header closeButton className='commonModalHeader'>
                <Modal.Title>
                    <div className="commonModalTitle"><FormattedMessage {...messages.providerApprovalModalTitle} /></div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='commonModalBody'>
                <div className={cx("commonModalContent",cs.space2)}>
                    <FormattedMessage {...messages.providerApprovalModalContent} />
                </div>
                <div className="commonModalContent">
                    <FormattedMessage {...messages.providerApprovalModalContent1} />
                </div>
                <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                    <Button onClick={() => handleCancel()} className={cs.btnSecondary}>
                        <FormattedMessage {...messages.cancelButton} />
                    </Button>
                    <Button onClick={() => handleApprove()} className={cs.btnPrimary}>
                        <FormattedMessage {...messages.proceedWithApproval} />
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default (withStyles(cs, s)(ProviderApprovalModal));

